import styled from "@emotion/styled";
import { ReactNode, useEffect } from "react";
import useIsMobile from "../../hooks/useIsMobile";
import ProgressTracker from "../ProgressTracker";
import UserHeader from "./UserHeader";
import { useGetCurrentUserQuery } from "../../api/users";

const MobileView = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 56px;
`;

const DesktopView = styled.div<{ xl?: boolean | undefined }>`
  display: flex;
  width: 100%;
  ${({ xl }) => (xl ? "max-width: 100%;" : "")}
`;

const DesktopViewMain = styled.main<{
  xl?: boolean | undefined;
  showHeader?: boolean;
}>`
  padding: ${({ showHeader }) => (showHeader ? "80px 64px 64px 64px" : "64px")};
  margin-left: max(120px, calc((100vw - 808px) / 4));
  max-width: 808px;
  width: 100%;
`;

const MobileViewMain = styled.main<{ showHeader?: boolean }>`
  padding: ${({ showHeader }) =>
    showHeader ? "8px 24px 64px 24px" : "32px 24px 64px 24px"};
`;

interface Props {
  children: ReactNode;
  xl?: boolean;
  showHeader?: boolean;
  hideAttorneyServices?: boolean;
}

const Layout = ({
  children,
  xl,
  showHeader = true,
  hideAttorneyServices = false,
}: Props) => {
  const isMobile = useIsMobile();
  const { data: user } = useGetCurrentUserQuery();

  // Impact Identity Function
  useEffect(() => {
    if (!user?.id || typeof window === "undefined") return;

    if (window.ire) {
      window.ire("identify", {
        customerId: user.id,
        customProfileId: user.id,
        customerEmail: "",
      });
    }
  }, [user]);

  if (isMobile) {
    return (
      <MobileView>
        <MobileViewMain showHeader={showHeader}>
          {showHeader && <ProgressTracker />}
          {children}
        </MobileViewMain>
      </MobileView>
    );
  }
  return (
    <DesktopView xl={xl}>
      <DesktopViewMain xl={xl} showHeader={showHeader}>
        {showHeader && (
          <UserHeader hideAttorneyServices={hideAttorneyServices} />
        )}

        {children}
      </DesktopViewMain>
    </DesktopView>
  );
};

export default Layout;
